<template>
    <el-select
            v-model="currentValue"
            :size="size"
            :multiple="multiple"
            :collapse-tags="collapseTags"
            :filterable="filterable"
            :disabled="disabled"
            :clearable="clearable"
            @change="change($event)" :class="{'width100': width100}">
        <el-option v-for="contract in contracts" :key="contract.id"
                   :value="contract.id" :label="contract.name">

        </el-option>
    </el-select>
</template>

<script>
    import BillingServer from "@/api/billing";
    export default {
        name: "ContractSelect",
        props: {
            value: {},
            size: {},
            multiple: {},
            collapseTags: {},
            filterable: {},
            disabled: {},
            clearable: {},

            width100: {
                type: Boolean,
                default: true,
            },

            customerId: {
            },
        },
        data() {
            return {
                currentValue: null,
                contracts: []
            };
        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler(value) {
                    this.currentValue = value;
                }
            },
            customerId: {
                immediate: true,
                handler() {
                    this.load();
                }
            }
        },
        methods: {
            async load(search) {
                search = search == null ? {} : search;
                search.eq_customerId = this.customerId;
                let res = await BillingServer.contract.list(search);
                let contracts;
                if (res.data.success) {
                    contracts = res.data.data;
                }
                contracts = contracts == null ? [] : contracts;
                contracts.forEach(e => {
                    e.id = parseInt(e.id);
                });
                this.contracts = contracts;
                return Promise.resolve(contracts);
            },
            change(event) {
                this.$emit('input', event);
                this.$emit('change', event);
            },
        },
        mounted() {
            this.load();
        },
    }
</script>

<style scoped>

</style>